// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TwitchPlayer {
  width: 100%;
  background: var(--base_color1);
  display: flex;
  justify-content: center;
  margin: 0 0 16px;
}`, "",{"version":3,"sources":["webpack://./src/components/VideoContent/components/TwitchPlayer/index.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,8BAAA;EACA,aAAA;EACA,uBAAA;EACA,gBAAA;AACF","sourcesContent":[".TwitchPlayer {\n  width: 100%;\n  background: var(--base_color1);\n  display: flex;\n  justify-content: center;\n  margin: 0 0 16px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
